export default "__VITE_ASSET__O8VsC_nv__"